module.exports = __webpack_public_path__ + "static/img/Jarrod-Croker.368ee90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jarrod-Croker.jpg
// module id = EVM/
// module chunks = 0